export default import.meta.ROLLDOWN_FILE_URL_ZDzJj_WcUdZlGrfR5dtceQ